import React from 'react'
import "./SubStyle.css"

const Soft_Audit = () => {
  return (
     <section className="SubServices">
     <h1 className="SubServices-title">Care Audit Software</h1>
      <p className="SubServices-pera">Enhance quality assurance through a streamlined auditing process. Our Care Audit Software enables providers to conduct inspections, track findings, monitor improvements, and maintain accurate records that support continuous service excellence.</p>
         <div className="btn-container">
        <button className="SubServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Soft_Audit
